/* STUB */
import React from 'react';

export default class MapBucket extends React.PureComponent {
    render() {
        return (
            <div />
        );
    }
}
